module.exports = __webpack_public_path__ + "static/img/light-course.91b1cd81.svg";